/* eslint-disable no-unused-vars */
import axios from "axios";
import { axiosPrivate } from ".";

export const getProducers = () =>
  axiosPrivate.post("loja/listar", { cache: true });

export const fetchLocation = locationType => {
  return axios.get(
    `https://api.eleventickets.com/BuscaEnderecos/${locationType}/?lang=pt`
  );
};
